import React, { Component } from 'react';
import moment from 'moment';
import PrintShipmentList from './PrintShipmentList';


const printAll = () => {
  window.print()
}

const HeaderButton = (props) => {
  if (props.shipment.status !== 'In Progress') {
    return (
      <div>
        <button type="button" className="btn btn-primary m-0 hidden-xs-down" onClick = {printAll}><i className="fa fa-print mr-05"></i> Packing List</button>
        <button type="button" className="btn btn-primary m-0 hidden-sm-up" onClick = {printAll}><i className="fa fa-print mr-05"></i>List</button>
        <PrintShipmentList shipment={props.shipment} backOrder={props.backOrder} />
      </div>
    )
  } else if (props.shipment.status === 'In Progress') {
    return (
      <div>
        <button type="button" className="btn btn-primary m-0" onClick = {props.finishShipment}><i className="fa fa-check mr-05"></i>Finish</button>
      </div>
    )
  }
}

const OrderData = ({ order }) => {
  return (
    <div className="card-block">
      <div className="row">
        <div className="col-sm-3">
          <h5>Market</h5>
          <p>
            {order.market}
          </p>
        </div>
        <div className="col-sm-3">
          <h5>User</h5>
          <p>
          {order.created_by}
          </p>
        </div>
        <div className="col-sm-3">
          <h5>Date</h5>
          <p>{ moment(order.sent_to_market_date).format('L') }</p>
        </div>
        <div className="col-sm-3">
          <h5>Delivery Date</h5>
          <p>{ moment(order.delivery_date).format('L') }</p>
        </div>
      </div>
    </div>
  )
}

export default class ShipmentDetailHeader extends Component {

  finishShipment = () => {
    let shipmentId = this.props.shipment.id;
    this.props.finishShipment(shipmentId);
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    let styleFrame = {
      height: '0px',
      width: '0px',
      position: 'absolute',
      display: 'none'
    }

    const editBtnStyle = {
      color: '#36a9e1',
      cursor: 'pointer'
    }

    const {
      shipment: { market_order: marketOrder },
      order,
      backOrder,
    } = this.props;

    return (
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          {!marketOrder ? (
            <h4>Shipment #{this.props.shipment.id} </h4>
          ) : (
            <h4>Order #{marketOrder}</h4>
          )}
          <HeaderButton
            shipment={this.props.shipment}
            finishShipment={this.finishShipment}
            backOrder={backOrder}
          />
          <iframe title="print" id="ifmcontentstoprint" style = {styleFrame} ></iframe>
        </div>
        { order && <OrderData order={order} /> }
        <div className="card-block">
          <div className="row">
          {marketOrder && (
            <div className="col-sm-3">
              <h5>Shipment #</h5>
              <p>{this.props.shipment.id}</p>
            </div>
            )}
            <div className="col-sm-3">
              <h5>Status</h5>
              <p>
                {this.props.shipment.status}
              </p>
            </div>
            {!marketOrder && (
              <div className="col-sm-3">
                <h5>Destination</h5>
                <p>
                {this.props.shipment.destination.name}
                {this.props.shipment.status === 'In Progress' && (
                  <a style={editBtnStyle} className="m-lg-h" onClick={this.props.openChangeDestinationModal}>
                    <i className="fa fa-edit"></i>
                  </a>
                )}
                </p>
              </div>
            )}
            <div className="col-sm-3">
              <h5>User</h5>
              <p>
              {this.props.shipment.user}
              </p>
            </div>
            <div className="col-sm-3">
              <h5>Date</h5>
              <p>
              {this.props.shipment.creation_date? moment(this.props.shipment.creation_date).format('L') : ''}
              {this.props.shipment.status === 'In Progress' && (
                <a style={editBtnStyle} className="m-lg-h" onClick={this.props.openChangeDateModal}>
                  <i className="fa fa-edit"></i>
                </a>
              )}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
